<template>
  <div class="payment-select__item">
    <div class="payment-select__item---left">
      <img class="payment-logo payment-select__item__logo" :src="imageSrc" />
    </div>
    <div class="payment-select__item---center">
      <span
        :id="item.id"
        :data-payment-name="item.code"
        :data-payment-provider="item.paymentType"
        class="payment-select__item__name"
      >
        {{ item.name }}
      </span>
    </div>
    <div class="payment-select__item---right">
      <span>Gateway Fee {{ gatewayFee }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { toKebabCase } from "@/composables/helpers/useStringHelpers.js";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

// TODO: This can be refactored to be reused by other select lists.
const props = defineProps({
  item: { type: Object, required: true },
});

const orderStore = useOrderFormStore();
const paymentsWithGenericCCImg = ["worldpaycredit", "checkoutcredit"];
const paymentsWithBankTransferImg = ["primetrust"];
// Below array contains PSP type
const paymentsWithSvgPreference = ["worldpaycredit", "dlocalspei"];

const gatewayFee = computed(() => {
  const showZeroFeeData = "0%";
  const activeFiat = orderStore.getFiatType;
  const activeCoin = orderStore.getCoinType;
  const correspondingFees = props.item.transaction_fees.find((fee) => {
    return fee.fiat_code === activeFiat && fee.coin_code === activeCoin;
  });

  if (!correspondingFees || correspondingFees.fees.length === 0) {
    return showZeroFeeData;
  }

  // fee property is an array
  const fee = correspondingFees.fees[0]?.amount;
  const feeIsPercentage = correspondingFees.fees[0]?.type === "percentage";

  if (feeIsPercentage) {
    return fee ? `${(fee * 100).toFixed(2)}%` : showZeroFeeData;
  }
  // flat fee
  return fee ? `${fee}.00` : "0";
});

const mapCodeToIconPath = (code) => {
  if (paymentsWithGenericCCImg.includes(code)) {
    return "creditcard";
  }

  if (paymentsWithBankTransferImg.includes(code)) {
    return "banktransfer";
  }

  return code;
};

const imageSrc = computed(() => {
  const extension = paymentsWithSvgPreference.includes(
    props.item.code.toLowerCase()
  )
    ? "svg"
    : "png";

  const path = toKebabCase(
    `/images/logos/payments/${mapCodeToIconPath(
      props.item.paymentType.toLowerCase()
    )}.${extension}`
  );
  return path;
});
</script>
<style scoped lang="scss">
.payment-select__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: transform 250ms;
  width: 100%;
  flex-wrap: wrap;

  @media screen and (max-width: $screen-sm) {
    display: grid;
    grid-template-columns: 1fr 3fr;
  }

  &---left {
    flex-direction: row;
  }

  &---center {
    flex-direction: row;
    gap: 0.5rem;
  }

  &---right {
    flex-direction: row;
    margin-left: auto;
    margin-right: 0.5rem;
    line-height: 160%;
    font-size: 1.2rem;

    @media screen and (max-width: $screen-sm) {
      grid-column-start: 2;
      margin-left: 0;
      margin-right: auto;
    }
  }

  &__name {
    font-weight: 500;
    @include breakpoint($max-xs) {
      font-size: 1.25rem;
    }
  }

  &__logo {
    padding: 1rem;
    background: var(--payment-logo-background);
    border-radius: calc($border-radius / 2);
    margin-right: 1rem;
    object-fit: cover;
    max-width: 60px;
  }
}

.payment-select__item---selected {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 3fr 2fr;
  grid-template-rows: auto;
  align-items: center;
  transition: transform 250ms;
  padding: 1.5rem 0.8rem;

  @media screen and (max-width: $screen-sm) {
    grid-template-columns: 1fr 3fr;
  }

  .payment-select__item---left {
    grid-column-start: 1;
  }

  .payment-select__item---center {
    grid-column-start: 2;
    padding-left: 0.5rem;
  }

  .payment-select__item---right {
    grid-column-start: 3;
    @media screen and (max-width: $screen-sm) {
      grid-column-start: 2;
      margin-left: 0.5rem;
      margin-right: auto;
    }
  }
}
</style>
